import { POST_DRAFT_REPORT_SUCCESS } from './';

export default report => dispatch =>
  dispatch({
    type: POST_DRAFT_REPORT_SUCCESS,
    payload: { report },
  });
